import exponent from "./exponent.js";

export default function(step, value) {
  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
}



//////////////////
// WEBPACK FOOTER
// /home/circleci/pickle/~/d3-format/src/precisionPrefix.js
// module id = aFxy
// module chunks = 0